/**
 * Data Table  component Resolve Formatted Value
 *
 * @package ext-components-base
 * @copyright 2021-2025 Hexio a.s. <contact@hexio.io> (hexio.io) and contributors.
 * @license Apache-2.0
 *
 * See LICENSE file distributed with this source code for more information.
 */

import {
	Type,
	createSubScope,
	ISchemaExpression,
	ISchemaScopedTemplateSpec
} from "@adapptio/lib-blueprint";

import { isFunction, isString, isValidValue } from "@adapptio/lib-shared";
import { TResolvedItemValue } from "./state";

/**
 * Resolves Formatted Value
 *
 * @param value Value
 * @param formatter Formatter
 */
export function resolveFormattedValue(
	value: TResolvedItemValue,
	formatter?: ISchemaScopedTemplateSpec<ISchemaExpression>
): string {
	if (isFunction(formatter)) {
		const formattedValue = formatter((parentScope) => {
			return createSubScope(parentScope, { value }, { value: Type.Any({}) });
		});

		if (isString(formattedValue)) {
			return formattedValue;
		}

		if (isValidValue(formattedValue)) {
			return `${formattedValue}`;
		}
	}

	return null;
}
